'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _reactI18next = require('react-i18next');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Info = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Info, _Component);

  function Info() {
    (0, _classCallCheck3.default)(this, Info);
    return (0, _possibleConstructorReturn3.default)(this, (Info.__proto__ || (0, _getPrototypeOf2.default)(Info)).apply(this, arguments));
  }

  (0, _createClass3.default)(Info, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          user = _props.user;

      var styles = require('./Info.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.infoPartition, { homeContent: !user, 'container-fluid': !!user }) },
        _react2.default.createElement(
          'ul',
          { className: 'tabs' },
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: '/info/terms-of-service' },
            _react2.default.createElement(
              _NavItem2.default,
              null,
              t('terms of service')
            )
          ),
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: '/info/privacy-policy' },
            _react2.default.createElement(
              _NavItem2.default,
              null,
              t('privacy policy')
            )
          ),
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: '/info/security' },
            _react2.default.createElement(
              _NavItem2.default,
              null,
              t('security')
            )
          ),
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: '/info/copyright-policy' },
            _react2.default.createElement(
              _NavItem2.default,
              null,
              t('copyright policy')
            )
          ),
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: '/info/cookie-policy' },
            _react2.default.createElement(
              _NavItem2.default,
              null,
              t('cookie policy')
            )
          ),
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: '/info/contact-us' },
            _react2.default.createElement(
              _NavItem2.default,
              null,
              t('contact us')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.props.mainChild
        )
      );
    }
  }]);
  return Info;
}(_react.Component), _class2.propTypes = {
  mainChild: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = Info;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Info/Info.js
// module id = 2160
// module chunks = 1